export const DEFAULT_ZOOM = 18
export const POI_ZOOM = 18
export const ZOOM_STEP_DELAY_MS = 100
export const MAP_FIT_PADDING = 28
/** Minimum span so fitBounds does not treat a single point as the whole world. */
export const MIN_BOUNDS_PAD_DEG = 0.002

export const PIN_COLOR = '#EA4335'
export const POI_DOT_COLOR = 'var(--site-brand-color)'
export const MARKER_SIZE_PX = 70

/** Category `poiMarker` size from the Home map design (38 Hug × 30 Hug). */
export const POI_MARKER_WIDTH = 38
export const POI_MARKER_HEIGHT = 30
